<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14ZrjHt/tc-custom/9780061750588.jpg?1731883381550" alt="This image is the cover for the book Pursuit of Happyness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pursuit of Happyness
      </h1>
      <p class="bookDescription body article font2">
        <b>The rags-to-riches saga of a homeless father who went on to become a crown prince of Wall Street—the basis for the major motion picture starring Will Smith.</b><br/><br/>At the age of twenty, Milwaukee native Chris Gardner, just out of the Navy, arrived in San Francisco to pursue a promising career in medicine. Considered a prodigy in scientific research, he surprised everyone and himself by setting his sights on the competitive world of high finance. Yet no sooner had he landed an entry-level position at a prestigious firm than Gardner found himself caught in a web of incredibly challenging circumstances that left him as part of the city’s working homeless and with a toddler son. Motivated by the promise he made to himself as a fatherless child to never abandon his own children, the two spent almost a year moving among shelters, “HO-tels,” soup lines, and even sleeping in the public restroom of a subway station.<br/><br/>Never giving in to despair, Gardner made an astonishing transformation from being part of the city’s invisible poor to being a powerful player in its financial district.<br/><br/>More than a memoir of Gardner’s financial success, this is the story of a man who breaks his own family’s cycle of men abandoning their children. Mythic, triumphant, and unstintingly honest, The Pursuit of Happyness conjures heroes like Horatio Alger and Antwone Fisher, and appeals to the very essence of the American Dream.<br/><br/><b>“Gardner is honest and thorough as he solidly depicts growing up black and male in late twentieth-century urban America . . . a quality African-American/business memoir deserving a wider audience than its niche-market elements might suggest.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Gardner, Quincy Troupe
      </h2>
      
      <p class="authorDescription body article"><P>Chris Gardner is the Chief Executive of Gardner Rich &#38; Company, a multimillion-dollar brokerage with offices in New York, Chicago, and San Francisco. An avid philanthropist and motivational speaker, Gardner is committed to many organizations&#8212;particularly those related to education&#8212;and was recently the recipient of the &#8220;Father of the Year Award&#8221; from the National Fatherhood Initiative. A Milwaukee native, Gardner has two children and resides in Chicago and New York.<B></B></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?625414ff